export default __webpack_public_path__ + "static/media/hero-level-4-chars-mob.b07263af.webp";